// regex must represent men check
const getGenderByRegex = (regex: RegExp, pathname: string): Gender => regex.test(pathname) ? 'male' : 'female'

const _getGenderByPathname = (pathname: string): Gender => {
  let gender: Gender

  if (/(main|bestsellers|collections|skincare)-(men|women)/.test(pathname)) {
    gender = getGenderByRegex(/-men/, pathname)
  }

  if (/(tastemakers|tastemakers-men)/.test(pathname)) {
    gender = getGenderByRegex(/-men/, pathname)
  }

  if (/(skincare|skincare-men)\/collections/.test(pathname)) {
    gender = getGenderByRegex(/-men/, pathname)
  }

  if (/onboarding/.test(pathname)) {
    gender = getGenderByRegex(/men/, pathname)
  }

  if (/(perfume|cologne|fragrance)/.test(pathname) && !/profile/.test(pathname)) {
    gender = getGenderByRegex(/(cologne|fragrance)/, pathname)
  }

  if (/^\/(perfume|cologne|fragrance)/.test(pathname) && !/profile/.test(pathname)) {
    gender = getGenderByRegex(/^\/(cologne|fragrance)/, pathname)
  }

  if (/(perfumes?|colognes?|fragrances?)$/.test(pathname) && !/profile/.test(pathname)) {
    gender = getGenderByRegex(/(colognes?|fragrances?)$/, pathname)
  }

  if (/.+-(for-men|for-boys|for-women|for-ladies|for-girls)/.test(pathname)) {
    gender = getGenderByRegex(/(for-men|for-boys)/, pathname)
  }

  if (/.+-(for-him|for-her)/.test(pathname)) {
    gender = getGenderByRegex(/for-him/, pathname)
  }

  if (/\/(women|men)/.test(pathname)) {
    gender = getGenderByRegex(/\/men/, pathname)
  }

  return gender
}

// TODO: Get typed State
const getGenderByPathname = (state: ReduxState): Gender => {
  const { models: { me: { gender } }, routing: { location: { pathname } } } = state

  return _getGenderByPathname(pathname) || gender
}


export default getGenderByPathname

export {
  _getGenderByPathname,
}
